import { render, staticRenderFns } from "./TableSortArrow.vue?vue&type=template&id=6ce4e410&scoped=true&"
import script from "./TableSortArrow.vue?vue&type=script&lang=js&"
export * from "./TableSortArrow.vue?vue&type=script&lang=js&"
import style0 from "./TableSortArrow.vue?vue&type=style&index=0&id=6ce4e410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4e410",
  null
  
)

export default component.exports